export const  data = {
    "name" : "HESTIA",
    "urlClient" : "https://hestia.pages.dev",
    "urlServer":"https://hestiaserver.herokuapp.com",
    "social":[
        {
            "name" : "instagram",
            "svg":" bi-instagram",
            "url": "https://www.instagram.com//"
        },
        {
            "name" : "facebook",
            "svg":"bi-facebook",
            "url": "https://www.facebook.com/"
        },
        {
            "name" : "email",
            "svg":"bi-envelope-fill",
            "url": "hermesdev9@gmail.com"
        }

    ],

    "email":"falcon@gmail.com",
    "Deliveries_price":{
        "normal":0,
        "normalDelay" :"entre 2 à 3 semaines",
        "prenieum": 20,
        "preniemDelay":"entre 2 à 7 jours"
    }
}
 